import { render, staticRenderFns } from "./DiscountsOverview.vue?vue&type=template&id=56b6d6dc&"
import script from "./DiscountsOverview.js?vue&type=script&lang=js&"
export * from "./DiscountsOverview.js?vue&type=script&lang=js&"
import style0 from "./DiscountsOverview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DiscountsOverview.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fcvb%2Fcomponents%2Fcontent%2FDiscountsOverview%2FDiscountsOverview.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports